import React from 'react';
import Style from './NotFoundPage.style';

export const NotfoundPage: React.FunctionComponent<any> = () => {
   return <Style>Página não encontrada</Style>;
};
